import React from 'react';

// ICONS
import { Loading3QuartersOutlined } from '@ant-design/icons';

// STYLES
import './styles.scss';

function Loader({ loaderStatus }: { loaderStatus: string }) {
    return (
        <div className="loader-container">
            <Loading3QuartersOutlined spin className="loader-icon" />
            {/* <div className="loader">
                <div className="u"><img src="../../assets/img/U.png" /></div>
                <div className="n"><img src="../../assets/img/N.png" /></div>
                <div className="x"><img src="../../assets/img/X.png" /></div>
                <div className="d"><img src="../../assets/img/D.png" /></div>
                <div className="dot"><img src="../../assets/img/DOT.png" /></div>
            </div> */}
            <div className="loader-status-content">{loaderStatus}</div>
        </div>
    );
}

export default Loader;